import {convertHex2Array} from "../../../utils";

/**
 * Set renderer
 * @param layer
 */
export function setServiceIntensityLayerRenderer(layer){
    let renderer;
    if(layer.subType === 'assigned'){
        renderer = {
            type: "simple",  // autocasts as new SimpleRenderer()
            symbol: {
                type: "simple-fill",
                style:  "solid",
                size: "8px",
                outline: 'none',
            },
            visualVariables: {
                type: "color",
                field: "intensityAssigned",
                stops: [
                    {value: 0, color: [247, 132, 12, 0.5]},
                    {value: 1, color: layer.serviceClassAssigned1 ? convertHex2Array(layer.serviceClassAssigned1, 0.5) : [247, 132, 12, 0.5]},
                    {value: 2, color: layer.serviceClassAssigned2 ? convertHex2Array(layer.serviceClassAssigned2, 0.5) : [247, 132, 12, 0.5]},
                    {value: 3, color: layer.serviceClassAssigned3 ? convertHex2Array(layer.serviceClassAssigned3, 0.5) : [247, 132, 12, 0.5]},
                    {value: 4, color: layer.serviceClassAssigned4 ? convertHex2Array(layer.serviceClassAssigned4, 0.5) : [247, 132, 12, 0.5]}
                ]
            }
        };
    } else{
        renderer = {
            type: "class-breaks",  // autocasts as new SimpleRenderer()
            field: "intensityReal",
            classBreakInfos: [
                {
                    minValue: 0,
                    maxValue: 0,
                    symbol: {
                        type: "simple-fill", // autocasts as new SimpleFillSymbol()
                        color: [247, 132, 12, 1],
                        style: "none",
                        outline: {color: [247, 132, 12, 1], width: 2}
                    },
                },
                {
                    minValue: 1,
                    maxValue: 1,
                    symbol: {
                        type: "simple-fill", // autocasts as new SimpleFillSymbol()
                        color: layer.serviceClassReal1 ? convertHex2Array(layer.serviceClassReal1, 1) : [247, 132, 12, 1],
                        style: "none",
                        outline: {color: layer.serviceClassReal1 ? convertHex2Array(layer.serviceClassReal1, 1) : [247, 132, 12, 1], width: 2}
                    },
                },
                {
                    minValue: 2,
                    maxValue: 2,
                    symbol: {
                        type: "simple-fill", // autocasts as new SimpleFillSymbol()
                        color: layer.serviceClassReal2 ? convertHex2Array(layer.serviceClassReal2, 1) : [247, 132, 12, 1],
                        style: "none",
                        outline: {color: layer.serviceClassReal2 ? convertHex2Array(layer.serviceClassReal2, 1) : [247, 132, 12, 1], width: 2}
                    },
                },
                {
                    minValue: 3,
                    maxValue: 3,
                    symbol: {
                        type: "simple-fill", // autocasts as new SimpleFillSymbol()
                        color: layer.serviceClassReal3 ? convertHex2Array(layer.serviceClassReal3, 1) : [247, 132, 12, 1],
                        style: "none",
                        outline: {color: layer.serviceClassReal3 ? convertHex2Array(layer.serviceClassReal3, 1) : [247, 132, 12, 1], width: 2}
                    },
                },
                {
                    minValue: 4,
                    maxValue: 4,
                    symbol: {
                        type: "simple-fill", // autocasts as new SimpleFillSymbol()
                        color: layer.serviceClassReal4 ? convertHex2Array(layer.serviceClassReal4, 1) : [247, 132, 12, 1],
                        style: "none",
                        outline: {color: layer.serviceClassReal4 ? convertHex2Array(layer.serviceClassReal4, 1) : [247, 132, 12, 1], width: 2}
                    },
                }
            ]
        };
    }



    layer.renderer = renderer;
}

/**
 * Clone layer and sort all layers
 * @param layers
 * @param sort
 */
export function prepareServiceIntensityLayers(layers, sort = false) {
    let newLayers = [];
    for (let layerIdx in layers){
        let layer = layers[layerIdx];
        if(layer.useServiceIntensityColors){
            let newLayer = Object.assign({}, layer);
            newLayer.name = layer.name + " _ategelik"; //Will be replaced _ategelik -> tegelik. Need for layers position
            newLayer.subType = "";
            newLayers.push(newLayer);

            let newAssignedLayer = Object.assign({}, layer);
            newAssignedLayer.name = newAssignedLayer.name + " määratud";
            newAssignedLayer.subType = "assigned";
            newAssignedLayer.id += "_assigned";
            newLayers.push(newAssignedLayer);
        } else{
            newLayers.push(layer);
        }
    }

    //Sort layers
    if(sort){
        sortLayers(newLayers);
    }

    for (let idx in newLayers){
        let layer = newLayers[idx];
        if(layer.useServiceIntensityColors){
            layer.name = layer.name.replace("_ategelik", "tegelik");
        }
    }

    return newLayers;
}

export function getServiceIntensityPolygonAssigned(serviceIntensityCode, layer) {
    let color = [247, 132, 12, 0.5];
    if (serviceIntensityCode === 1)
        color = layer.serviceClassAssigned1 ? convertHex2Array(layer.serviceClassAssigned1, 0.5) : [247, 132, 12, 0.5];
    else if (serviceIntensityCode === 2)
        color = layer.serviceClassAssigned2 ? convertHex2Array(layer.serviceClassAssigned2, 0.5) : [247, 132, 12, 0.5];
    else if (serviceIntensityCode === 3)
        color = layer.serviceClassAssigned3 ? convertHex2Array(layer.serviceClassAssigned3, 0.5) : [247, 132, 12, 0.5];
    else if (serviceIntensityCode === 4)
        color = layer.serviceClassAssigned4 ? convertHex2Array(layer.serviceClassAssigned4, 0.5) : [247, 132, 12, 0.5];
    return {
        type: "simple-fill",
        style: "solid",
        color: color,
        outline: 'none'
    };
}

export function getServiceIntensityPolygonReal(serviceIntensityCode, layer) {
    let outline = null;
    if (serviceIntensityCode === 0)
        outline = {color: [247, 132, 12, 1], width: 2};
    else if (serviceIntensityCode === 1)
        outline = {color: layer.serviceClassReal1 ? convertHex2Array(layer.serviceClassReal1, 1) : [247, 132, 12, 1], width: 2};
    else if (serviceIntensityCode === 2)
        outline = {color: layer.serviceClassReal2 ? convertHex2Array(layer.serviceClassReal2, 1) : [247, 132, 12, 1], width: 2};
    else if (serviceIntensityCode === 3)
        outline = {color: layer.serviceClassReal3 ? convertHex2Array(layer.serviceClassReal3, 1) : [247, 132, 12, 1], width: 2};
    else if (serviceIntensityCode === 4)
        outline = {color: layer.serviceClassReal4 ? convertHex2Array(layer.serviceClassReal4, 1) : [247, 132, 12, 1], width: 2};


    return {
        type: "simple-fill", // autocasts as new SimpleFillSymbol()
        color: null,
        style: "none",
        outline: outline
    };
}

/**
 *
 * @param layers
 */
export function sortLayers(layers){
    layers.sort((a,b) => (a.name > b.name) ? -1 : ((b.name > a.name) ? 1 : 0));
    for (let layerIdx in layers) {
        layers[layerIdx].index = parseInt(layerIdx);
    }
}